import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../../features/userSlice";
import { fetchMyFeatureRequests } from "../../../views/FeatureRequests/featureRequestsApi";
import { statusLabel } from "../../../views/FeatureRequests/featureRequestStatus";
import WidgetFrame, { WidgetEmpty } from "./WidgetFrame";

const OPEN_STATUSES = ["new", "planned", "in_progress"];

// Where the user's own feature requests stand — open count plus the latest
// few with their status.
const MyFeatureRequestsWidget = () => {
  const user = useSelector(selectUser);
  const [requests, setRequests] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!user?.email) return;
    fetchMyFeatureRequests(user.email)
      .then((list) => setRequests(Array.isArray(list) ? list : []))
      .catch(() => setFailed(true));
  }, [user?.email]);

  if (!requests) {
    return (
      <WidgetFrame title="My Feature Requests" to="/forms/feature-request">
        <WidgetEmpty>
          {failed ? "Couldn't load your requests." : "Loading your requests…"}
        </WidgetEmpty>
      </WidgetFrame>
    );
  }

  const open = requests.filter((r) => OPEN_STATUSES.includes(r.status));
  const recent = requests.slice(0, 3); // API returns newest first

  return (
    <WidgetFrame title="My Feature Requests" to="/forms/feature-request">
      <p className="flex items-baseline gap-1.5 text-sm">
        <span className="text-2xl font-semibold tabular-nums tracking-tight">{open.length}</span>{" "}
        <span className="app-muted">open</span>
      </p>
      {recent.length > 0 ? (
        <ul className="mt-2.5 space-y-1.5">
          {recent.map((request) => (
            <li
              key={request._id}
              className="flex items-center justify-between gap-2 text-sm"
            >
              <span className="truncate font-medium">{request.title}</span>
              <span className="app-muted shrink-0 text-xs">
                {statusLabel(request.status)}
              </span>
            </li>
          ))}
        </ul>
      ) : (
        <WidgetEmpty>You haven't asked for anything yet.</WidgetEmpty>
      )}
    </WidgetFrame>
  );
};

export default MyFeatureRequestsWidget;
